const QUERY_REGEXP = /"([^"\\]*(?:\\.[^"\\]*)*)"|[^\s]+/g;
const ESCAPE_CLEANER_REGEXP = /\\+"/g;

export const tokenizeSearchQuery = (query: string): string[] =>
  (query.toLowerCase().match(QUERY_REGEXP) || []).reduce((acc, token) => {
    const quoteLessBody = token.match(/^"(?<body>.*)"$/);
    const cleanToken = (quoteLessBody?.groups?.body || token)
      .trim()
      .replace(ESCAPE_CLEANER_REGEXP, '"');

    if (cleanToken !== "" && cleanToken !== '"') acc.push(cleanToken);

    return acc;
  }, [] as string[]);

export const matchesSearchQuery = (queryTokens: string[], texts: string[]): boolean => {
  const lowerTexts = texts.map((text) => text.toLowerCase());

  return queryTokens.every((queryToken) =>
    lowerTexts.some((lowerText) => lowerText.includes(queryToken))
  );
};
